module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "with-content": true,
      "theme": true,
      "fix-height": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.typeUpload === "pdf" ? _vm.$t("help.newPdf") : _vm.$t("help.newVideo")))]), _vm._v(" "), _c('div', {
    staticClass: "content-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t("template.form.name")) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.help.name),
      expression: "help.name"
    }],
    staticClass: "form-control",
    attrs: {
      "max-length": 100,
      "type": "text",
      "required": true,
      "id": "staticEmail"
    },
    domProps: {
      "value": (_vm.help.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.help.name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.typeUpload === 'video') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t("template.form.link")) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.help.link),
      expression: "help.link"
    }],
    staticClass: "form-control",
    attrs: {
      "max-length": 255,
      "type": "text",
      "required": true
    },
    domProps: {
      "value": (_vm.help.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.help.link = $event.target.value
      }
    }
  })])])]) : (_vm.typeUpload === 'pdf') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t("template.form.link")) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "max-length": 255,
      "type": "file",
      "required": true,
      "accept": "application/pdf",
      "id": "file"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row align-items-center"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t("template.form.category")) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "d-flex justify-content-start flex-wrap apps"
  }, _vm._l((_vm.applications), function(app, key) {
    return _c('button', {
      key: key,
      class: _vm.help.applicationId === app.id ? 'btn btn-primary' : 'btn btn-dark',
      on: {
        "click": function($event) {
          _vm.changeApp(app)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(app.title) + "\n                        ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center align-items-center actions"
  }, [_c('button', {
    staticClass: "btn btn-dark",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dark",
    on: {
      "click": _vm.upload
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))])])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3376312","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/help/modales/ModalHelpUpload.vue
// module id = 3384
// module chunks = 0